import { observable, action, decorate } from 'mobx';

class AppModule {
    modalData = null;

    setModalData(data) {
        this.modalData = data;
    }
}

decorate(AppModule, {
    modalData: observable,
    setModalData: action.bound,
});

export default AppModule;
